import { FC } from 'react'
import * as React from 'react'
import styled from 'styled-components'
import { UserScrapType } from 'generated/graphql'
import LineTabs from '@app.components/tabs/LineTabs/LineTabs'
import { useScrapStateContext } from '../../../../../screens/ScrapScreen/useScrapState'

const CoverLetterScrapListFilterMobile: FC = () => {
  const { setTabState } = useScrapStateContext()

  const tabs = [
    {
      id: 0,
      name: '전체',
      size: '100px',
      href: {
        query: { tab: UserScrapType.COVER_LETTER_AND_PARAGRAPH },
      },
      value: UserScrapType.COVER_LETTER_AND_PARAGRAPH,
    },
    {
      id: 1,
      name: '문장스크랩',
      size: '100px',
      href: {
        query: { tab: UserScrapType.COVER_LETTER_PARAGRAPH },
      },
      value: UserScrapType.COVER_LETTER_PARAGRAPH,
    },
    {
      id: 2,
      name: '전문스크랩',
      size: '100px',
      href: {
        query: { tab: UserScrapType.COVER_LETTER },
      },
      value: UserScrapType.COVER_LETTER,
    },
  ]

  const handleChange = (value: UserScrapType) => {
    setTabState(value)
  }

  return (
    <StyledWrapper>
      <div className="tabs-content">
        <CustomLineTabs
          data={tabs}
          initialTab={tabs[0]}
          savePrevQuery
          onChange={handleChange}
        />
      </div>
    </StyledWrapper>
  )
}

export default CoverLetterScrapListFilterMobile

const StyledWrapper = styled.div`
  background-color: white;
  z-index: 100;
  .tabs-content {
    max-width: 1148px;
    margin: 0 auto;
    width: 100%;
    border-top: 1px solid #e8e8e8;
  }
`

const CustomLineTabs = styled(LineTabs)`
  height: 50px;
`
